export default {
    namespaced: true,
    state: {
        invoice: ""
    },

    actions: {

        add: ({rootState}, note) => {
            return new Promise((resolve, reject) => {
                rootState.init.http_common.post('/facturas', JSON.stringify(note))
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        downloadXml:({rootState}, uuid) => {
            return new Promise((resolve, reject) => {
                rootState.init.http_common.get(`/download/${uuid}/xml`, {responseType: 'blob'})
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        downloadPdf:({rootState}, uuid) => {
            return new Promise((resolve, reject) => {
                rootState.init.http_common.get(`/download/${uuid}/pdf`, {responseType: 'blob'})
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

    }

}
